import { Card, CardContent, CardHeader } from '@/components/ui/card';

interface FormSectionCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function FormSectionCard({
  title,
  description,
  children,
}: FormSectionCardProps) {
  return (
    <Card>
      <CardHeader className="pb-4">
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>
          {description && (
            <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
          )}
        </div>
      </CardHeader>
      <CardContent className="pt-0">{children}</CardContent>
    </Card>
  );
}
